import { withLazyComponent } from '@document/utils/lazy-component';
import { lazy } from 'react';

export const LoginPage = withLazyComponent(
  lazy(async () => ({
    default: (await import('./LoginPage')).LoginPage,
  }))
);

export const LogoutPage = withLazyComponent(
  lazy(async () => ({
    default: (await import('./LogoutPage')).LogoutPage,
  }))
);
